import { render, staticRenderFns } from "./CreatePreadvice.vue?vue&type=template&id=737892f6&scoped=true&"
import script from "./CreatePreadvice.vue?vue&type=script&lang=js&"
export * from "./CreatePreadvice.vue?vue&type=script&lang=js&"
import style0 from "./CreatePreadvice.vue?vue&type=style&index=0&id=737892f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737892f6",
  null
  
)

export default component.exports